// extracted by mini-css-extract-plugin
export default {"steps-list":"X67T6TZqLx8iCqYI13Cw","stepsList":"X67T6TZqLx8iCqYI13Cw"};